import React from 'react';
import ReactDOM from 'react-dom';

import Main from './pages/Main';

import DataForPrint from './pages/DataForPrint'
import ShoppingCart from './pages/ShoppingCart'
import IdPDFReuse from './pages/IdPDFReuse';
import * as serviceWorker from './serviceWorker';
import './css/theme.css';
import './css/insertPhoto.css';
import './css/tui-image-editor.css';
import './css/color.css';
import './css/fonts.css';
import './css/mapa-carta.css';
import './css/all.css';
import './resources/i18n';

//import fa from 'font-awesome';

import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';

ReactDOM.render(<Router basename="/mapaalacarta">
  <Switch>
    <Route path="/" exact={true} component={Main}/>
    <Route path="/DataForPrint" exact={true} component={DataForPrint} />
    <Route path="/ShoppingCart" exact={true} component={ShoppingCart} />
    <Route path="/IdPDFReuse" exact={true} component={IdPDFReuse} />
  </Switch>
</Router>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
